module.exports = __webpack_public_path__ + "static/media/user-edit.e42f8c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-edit.png
// module id = 471
// module chunks = 33